import { FC } from "react";
import { Outlet } from "react-router-dom";
import styles from "./index.module.css";

export const LandingHeader: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <mui-v-stack class={styles.landingHeader}>{children}</mui-v-stack>;
};

export const LandingSection: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <mui-v-stack space="var(--space-500)">{children}</mui-v-stack>;
};

export const BreadCrumbHeading: FC<{
  link: string;
  to: string;
  page: string;
}> = ({ page, to, link }) => {
  return (
    <mui-h-stack space="var(--space-300)" alignY="center">
      <mui-link href="/home">
        Home
      </mui-link>
      <mui-body style={{ fontWeight: 500 }}>»</mui-body>
      <mui-link href={to}>
        {link}
      </mui-link>
      <Outlet />

      <mui-body style={{ fontWeight: 500 }}>»</mui-body>
      <mui-body weight="bold">{page}</mui-body>
    </mui-h-stack>
  );
};
